import { Reveal } from "./Reveal";
import { Globe, Users, HardHat, Package, Truck, Hotel, Factory, Wheat, Building2 } from "lucide-react";

const SERVICES = [
  [Globe, "International Recruitment", "Cross-border sourcing of talent into European roles."],
  [Users, "Skilled & Semi-Skilled Workforce", "Reliable workers matched to real requirements."],
  [HardHat, "Construction Recruitment", "Labourers and trades for European construction."],
  [Package, "Logistics & Warehouse", "Warehouse, packaging and logistics staffing."],
  [Truck, "Truck & Professional Drivers", "Qualified professional drivers for EU transport."],
  [Hotel, "Hospitality & Tourism", "Hotel, kitchen and service staff, incl. seasonal."],
  [Factory, "Manufacturing & Production", "Production line and factory workforce."],
  [Wheat, "Seasonal Workforce", "Agricultural and seasonal manpower on demand."],
  [Building2, "Employer Recruitment Solutions", "End-to-end hiring support for employers."],
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-32 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20 items-end">
        <Reveal className="lg:col-span-8">
          <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
            What we do
          </p>
          <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl">
            Workforce
            <br />
            solutions.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-4">
          <p className="font-body text-[#52525b] leading-relaxed">
            International recruitment and workforce sourcing across Europe's core sectors — with
            verification built into every placement.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 border-t border-l border-[#e4e4e7]">
        {SERVICES.map(([Icon, title, body], i) => (
          <Reveal key={title} delay={(i % 3) * 0.07} className="group border-b border-r border-[#e4e4e7]">
            <div data-testid={`service-${i}`} className="h-full p-8 md:p-10 relative transition-colors duration-500 hover:bg-[#f4f4f5]">
              <div className="flex items-center justify-between mb-14 md:mb-16">
                <Icon size={28} className="text-[#ff3b30]" strokeWidth={1.4} />
                <span className="font-head text-[#e4e4e7] text-5xl group-hover:text-[#ff3b30]/20 transition-colors duration-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-head uppercase tracking-tight text-2xl md:text-3xl mb-4">{title}</h3>
              <p className="font-body text-[#52525b] leading-relaxed">{body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
